module.exports = __webpack_public_path__ + "static/img03-9124bc40caa390724d4588682a658f02.jpg";